import React from 'react';
import { useRecoilValue } from 'recoil';
import { useTheme } from 'styled-components';

import useLoginForward from '@ecp/common/src/hooks/useLoginForward';
import { FlexBox, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import TextLink from '@ecp/common/src/text/TextLink';
import { TextButton } from '@ecp/common/src/components/button/TextButton';
import { ReactComponent as InquiryIcon } from '@ecp/common/src/assets/icon/icon__inquiry.svg';

import { userInfoState } from '@fo-recoil/common/user/atom';
import { getOtoQuestUseYn } from '@fo-recoil/system/selector';
import useSiteInfo from '@fo-hooks/common/useSiteInfo';
import { useConfirmDialog } from '@fo-hooks/common/useModal';
import { PRIVACY_POLICY_TITLE, TERM_OF_USE_TITLE } from '@fo-components/system/const';

export default function SkypassFooterTermsAndConditions() {
  const theme = useTheme();
  const { showConfirmDialog } = useConfirmDialog();
  const { login } = useRecoilValue(userInfoState);
  const { siteNumber } = useSiteInfo();
  const loginForward = useLoginForward(siteNumber, showConfirmDialog);
  const otoQuestUseYn = useRecoilValue(getOtoQuestUseYn);

  const handleLoginClick = (e) => {
    e.preventDefault();
    if (!login) {
      loginForward();
    }
  };

  return (
    <FlexBoxSpaceBetween width={'1330px'} height={'56px'}>
      <FlexBox gap={'20px'} data-ds-label2={'f_info'}>
        {/* 이용약관 버튼 */}
        <TextButton textProps={{ weight: '350' }}>
          <a
            href="https://www.koreanair.com/contents/footer/terms-and-policies/terms-of-use"
            target="_blank"
            rel="noreferrer"
            title="새 창 열림"
            style={{ color: theme.color.primary }}
          >
            {TERM_OF_USE_TITLE}
          </a>
        </TextButton>

        {/* 개인정보처리방침 버튼 */}
        <TextButton>
          <a
            href="https://www.koreanair.com/contents/footer/terms-and-policies/privacy-policy"
            target="_blank"
            rel="noreferrer"
            title="새 창 열림"
            style={{ color: theme.color.primary, fontWeight: 700 }}
          >
            {PRIVACY_POLICY_TITLE}
          </a>
        </TextButton>
      </FlexBox>
      <FlexBox width={'310px'} data-ds-label2={'f_cs'}>
        {otoQuestUseYn && login && (
          <TextLink gap={'6px'} to={'/customer-service/qna'}>
            <InquiryIcon />
            1:1문의
          </TextLink>
        )}
        {otoQuestUseYn && !login && (
          <TextLink gap={'6px'} onClick={handleLoginClick}>
            <InquiryIcon />
            1:1문의
          </TextLink>
        )}
      </FlexBox>
    </FlexBoxSpaceBetween>
  );
}
